<script>
import SimbgStatistik from '@/components/dashboard/simbg/Statistik.vue'
import SimbgPerBulan from '@/components/dashboard/simbg/PerBulan.vue'
import SimbgPerKecamatan from '@/components/dashboard/simbg/PerKecamatan.vue'
import SimbgPerFungsi from '@/components/dashboard/simbg/PerFungsi.vue'

export default {
   components: {
      SimbgStatistik,
      SimbgPerBulan,
      SimbgPerKecamatan,
      SimbgPerFungsi,
   },
}
</script>

<template>
   <div>
      <SimbgStatistik />
      <SimbgPerBulan />
      <SimbgPerKecamatan />
      <SimbgPerFungsi />
   </div>
</template>

<style scoped></style>
